var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame120(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6888 29.0431C57.4945 31.8654 61.7101 36.0525 65.1105 40.4604C65.7252 41.2573 66.8376 42.6522 67.793 43.0768C68.5468 43.4119 69.3632 44.5017 69.947 45.0854C70.5035 45.642 71.4617 45.9251 72.1934 46.169",
    stroke: "#7F66FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7179 42.6024C71.7179 49.505 72.6694 56.4261 72.6694 63.2962C72.6694 66.0381 73.1451 68.8871 73.1451 71.5024C73.1451 72.1521 73.7569 73.4132 73.2508 73.6432C71.9281 74.2444 69.5458 73.7621 68.1368 73.7621C65.0517 73.7621 61.9838 73.5243 58.8999 73.5243C52.8266 73.5243 46.7615 73.7621 40.7035 73.7621C37.9397 73.7621 35.1678 74 32.4709 74C32.0596 74 29.6722 73.8756 29.8016 73.7093C30.005 73.4477 29.8544 72.6066 29.8544 72.2821C29.8544 70.8549 29.8544 69.4278 29.8544 68.0006C29.8544 65.1463 29.8544 62.2919 29.8544 59.4376C29.8544 57.1219 30.1778 54.8497 30.0923 52.5397C30.0078 50.2588 29.3787 47.9735 29.3787 45.6417C29.3787 44.6286 29.3787 43.6155 29.3787 42.6024",
    stroke: "#7F66FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 47.8346C29.6298 45.7308 32.2721 43.6132 34.7173 41.2935C36.0176 40.0598 37.1978 38.5403 38.6552 37.4877C40.6347 36.058 41.8932 33.7952 43.6503 32.1358C46.2356 29.6941 49.9495 28.0389 51.9754 25",
    stroke: "#7F66FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0825 55.4466C40.557 56.8703 42.4701 58.3099 43.5315 59.3713C44.3117 60.1515 45.0507 60.6521 46.029 61.1552C48.3144 62.3306 51.0634 63.0581 53.6405 63.0581C56.2103 63.0581 58.1111 62.2852 59.706 60.3359C60.8617 58.9234 61.9657 56.0552 61.9657 54.2573",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame120);
export default __webpack_public_path__ + "static/media/Frame120.6f6cf60103f068e280285cb9858e66ff.svg";
export { ForwardRef as ReactComponent };